import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/calendar-check': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 64H352V12C352 5.4 346.6 0 340 0H300C293.4 0 288 5.4 288 12V64H160V12C160 5.4 154.6 0 148 0H108C101.4 0 96 5.4 96 12V64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V112C448 85.5 426.5 64 400 64zM394 464H54A6-6 0 0 0 48 458V160H400V458A6-6 0 0 0 394 464zM341.2 263.4L198.8 404.5C194.1 409.2 186.5 409.2 181.9 404.5L106.8 328.8C102.1 324 102.1 316.4 106.8 311.8L129.6 289.2C134.3 284.6 141.9 284.6 146.5 289.3L190.6 333.8 301.7 223.6C306.4 218.9 314 219 318.7 223.7L341.2 246.4C345.9 251.1 345.9 258.7 341.2 263.4z'
      }
    ]
  }
})
